export class Mediator {
    constructor() {
        this.mediaHost = "https://doski.mts-link.ru/boards/api/v2/static/media/";
    }

    async preload() {
        const names: string[] = [];

        Object.keys(this.data).forEach((key) => {
            names.push(key);
            // key: the name of the object key
            // index: the ordinal position of the key within the object
        });

        for (let i = 0; i < names.length; i++) {
            const img = new Image();
            img.src = this.Get(names[i]);
            // var meta = document.createElement('meta');
            // meta.setAttribute("type", "preload");
            // meta.setAttribute("as", "image");
            // meta.setAttribute("href", this.Get(names[i]));
            // page.appendChild(meta);
        }
    }

    Get(name: string) {
        return this.mediaHost + this.data[name];
    }

    mediaHost = "";

    data = {
        emote1: "emote/emote1.png",
        emote2: "emote/emote2.png",
        emote3: "emote/emote3.png",
        emote4: "emote/emote4.png",
        emote5: "emote/emote5.png",
        emote6: "emote/emote6.png",

        rotateCursorTopRight: "cursors/rotateCursorTopRight.svg",
        rotateCursorBottomRight: "cursors/rotateCursorBottomRight.svg",
        rotateCursorTopLeft: "cursors/rotateCursorTopLeft.svg",
        rotateCursorBottomLeft: "cursors/rotateCursorBottomLeft.svg",

        "2_meetings_workshops_1": "moreTool/templates/2_meetings_workshops_1.png",
        "2_meetings_workshops_2": "moreTool/templates/2_meetings_workshops_2.png",
        "2_meetings_workshops_3": "moreTool/templates/2_meetings_workshops_3.png",
        "2_meetings_workshops_4": "moreTool/templates/2_meetings_workshops_4.png",
        "2_meetings_workshops_5": "moreTool/templates/2_meetings_workshops_5.png",
        "2_meetings_workshops_6": "moreTool/templates/2_meetings_workshops_6.png",

        "2_brainstorming_ideation_1": "moreTool/templates/2_brainstorming_ideation_1.png",
        "2_brainstorming_ideation_2": "moreTool/templates/2_brainstorming_ideation_2.png",
        "2_brainstorming_ideation_3": "moreTool/templates/2_brainstorming_ideation_3.png",
        "2_brainstorming_ideation_4": "moreTool/templates/2_brainstorming_ideation_4.png",
        "2_brainstorming_ideation_5": "moreTool/templates/2_brainstorming_ideation_5.png",
        "2_brainstorming_ideation_6": "moreTool/templates/2_brainstorming_ideation_6.png",

        "2_strategy_planning_1": "moreTool/templates/2_strategy_planning_1.png",
        "2_strategy_planning_2": "moreTool/templates/2_strategy_planning_2.png",
        "2_strategy_planning_3": "moreTool/templates/2_strategy_planning_3.png",
        "2_strategy_planning_4": "moreTool/templates/2_strategy_planning_4.png",
        "2_strategy_planning_5": "moreTool/templates/2_strategy_planning_5.png",
        "2_strategy_planning_6": "moreTool/templates/2_strategy_planning_6.png",

        blogPreview1: "blog/blog1/blog1.svg",

        stickerBeauty1: "stickers/stickerBeauty1.png",
        stickerBeauty2: "stickers/stickerBeauty2.png",
        stickerBeauty3: "stickers/stickerBeauty3.png",
        stickerBeauty4: "stickers/stickerBeauty4.png",
        stickerBeauty5: "stickers/stickerBeauty5.png",
        stickerBeauty6: "stickers/stickerBeauty6.png",
        stickerBeauty7: "stickers/stickerBeauty7.png",
        stickerBeauty8: "stickers/stickerBeauty8.png",
        stickerBeauty9: "stickers/stickerBeauty9.png",
        stickerBeauty10: "stickers/stickerBeauty10.png",
        stickerBeauty11: "stickers/stickerBeauty11.png",
        stickerBeauty12: "stickers/stickerBeauty12.png",
        stickerBeauty13: "stickers/stickerBeauty13.png",
        stickerBeauty14: "stickers/stickerBeauty14.png",
        stickerBeauty15: "stickers/stickerBeauty15.png",
        stickerBeauty16: "stickers/stickerBeauty16.png",
        stickerBeauty17: "stickers/stickerBeauty17.png",
        stickerBeauty18: "stickers/stickerBeauty18.png",
        stickerBeauty19: "stickers/stickerBeauty19.png",
        stickerBeauty20: "stickers/stickerBeauty20.png",

        moSticker1: "stickers/moSticker1.png",
        moSticker2: "stickers/moSticker2.png",
        moSticker3: "stickers/moSticker3.png",
        moSticker4: "stickers/moSticker4.png",
        moSticker5: "stickers/moSticker5.png",
        moSticker6: "stickers/moSticker6.png",
        moSticker7: "stickers/moSticker7.png",
        moSticker8: "stickers/moSticker8.png",
        moSticker9: "stickers/moSticker9.png",
        moSticker10: "stickers/moSticker10.png",
        moSticker11: "stickers/moSticker11.png",
        moSticker12: "stickers/moSticker12.png",
        moSticker13: "stickers/moSticker13.png",
        moSticker14: "stickers/moSticker14.png",
        moSticker15: "stickers/moSticker15.png",
        moSticker16: "stickers/moSticker16.png",
        moSticker17: "stickers/moSticker17.png",
        moSticker18: "stickers/moSticker18.png",
        moSticker19: "stickers/moSticker19.png",
        moSticker20: "stickers/moSticker20.png",
        moSticker21: "stickers/moSticker21.png",

        blenderMoSticker1: "stickers/blenderMoSticker1.png",
        blenderMoSticker2: "stickers/blenderMoSticker2.png",
        blenderMoSticker3: "stickers/blenderMoSticker3.png",
        blenderMoSticker4: "stickers/blenderMoSticker4.png",
        blenderMoSticker5: "stickers/blenderMoSticker5.png",
        blenderMoSticker6: "stickers/blenderMoSticker6.png",
        blenderMoSticker7: "stickers/blenderMoSticker7.png",
        blenderMoSticker8: "stickers/blenderMoSticker8.png",
        blenderMoSticker9: "stickers/blenderMoSticker9.png",
        blenderMoSticker10: "stickers/blenderMoSticker10.png",
        blenderMoSticker11: "stickers/blenderMoSticker11.png",
        blenderMoSticker12: "stickers/blenderMoSticker12.png",
        blenderMoSticker13: "stickers/blenderMoSticker13.png",
        blenderMoSticker14: "stickers/blenderMoSticker14.png",

        BSB1: "stickers/BSB-1.png",
        BSB2: "stickers/BSB-2.png",
        BSB3: "stickers/BSB-3.png",
        BSB4: "stickers/BSB-4.png",
        BSB5: "stickers/BSB-5.png",
        BSB6: "stickers/BSB-6.png",
        BSB7: "stickers/BSB-7.png",
        BSB8: "stickers/BSB-8.png",
        BSB9: "stickers/BSB-9.png",
        BSB10: "stickers/BSB-10.png",
        BSB11: "stickers/BSB-11.png",
        BSB12: "stickers/BSB-12.png",
        BSB13: "stickers/BSB-13.png",
        BSB14: "stickers/BSB-14.png",
        BSB15: "stickers/BSB-15.png",
        BSB16: "stickers/BSB-16.png",
        BSB17: "stickers/BSB-17.png",
        BSB18: "stickers/BSB-18.png",
        BSB19: "stickers/BSB-19.png",
        BSB20: "stickers/BSB-20.png",
        BSB21: "stickers/BSB-21.png",
        BSB22: "stickers/BSB-22.png",
        BSB23: "stickers/BSB-23.png",
        BSB24: "stickers/BSB-24.png",
        BSB25: "stickers/BSB-25.png",
        BSB26: "stickers/BSB-26.png",
        BSB27: "stickers/BSB-27.png",
        BSB28: "stickers/BSB-28.png",
        BSB29: "stickers/BSB-29.png",
        BSB30: "stickers/BSB-30.png",
        BSB31: "stickers/BSB-31.png",
        BSB32: "stickers/BSB-32.png",
        BSB33: "stickers/BSB-33.png",
        BSB34: "stickers/BSB-34.png",
        BSB35: "stickers/BSB-35.png",

        logo: "site/logoExpBig2.svg",
    };
}
